import { createFileRoute } from '@tanstack/react-router'
import { GeneralConfig } from '~/features/webchat/components'
import { useSuspenseQuery } from '~/services'

export const Route = createFileRoute('/workspaces/$workspaceId/bots/$botId/webchat/v2/general')({
  component: Component,
})

function Component() {
  const { workspaceId, botId } = Route.useParams()
  const { plan } = useSuspenseQuery('workspaces_/$workspaceId_', { workspaceId }).data

  return <GeneralConfig workspaceId={workspaceId} botId={botId} plan={plan} />
}
